import Image from 'next/image';
import type { ImageIconProps } from './types';

export const IconYoutubeMusic = ({ width, height, className }: ImageIconProps) => {
  return (
    <Image
      src='/images/ui/icons/youtube_music.svg'
      width={width}
      height={height}
      alt='YoutubeMusic'
      className={className}
    />
  );
};
